import { render, staticRenderFns } from "./MonthlyLeaderboardCard.vue?vue&type=template&id=d20b2d0c"
import script from "./MonthlyLeaderboardCard.vue?vue&type=script&lang=js"
export * from "./MonthlyLeaderboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports